module.exports = __webpack_public_path__ + "img/atari1200_page2.d852af1b.jpg";